let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9qhMm")).then(() => parcelRequire('lRW0v'));